module.exports = __webpack_public_path__ + "img/57.cfddc085.png";